import React from 'react'
import DeactivateBillPayCard from 'src/app/DeactivateBillPayCard/DeactivateBillPayCard'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { deactivateBillPayCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const DeactivateBillPayCardAppRoute: AppRoute = {
  id: AppLocation.DeactivateBillPayCard,
  routeProps: deactivateBillPayCardRouteProps,
  component: <DeactivateBillPayCard />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default DeactivateBillPayCardAppRoute
